module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-top.519ad124.svg";